import { render } from "./Construct.vue?vue&type=template&id=16bf2b0b&scoped=true"
import script from "./Construct.vue?vue&type=script&lang=js"
export * from "./Construct.vue?vue&type=script&lang=js"

import "./Construct.vue?vue&type=style&index=0&id=16bf2b0b&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bf2b0b"]])

export default __exports__